'use client';

import { Button } from '@galapagos/design-system/web';
import { useTranslation } from 'react-i18next';
import { useSignupNavigation } from '../../hooks/useSignupNavigation';
import { useStepHeading } from '../../hooks/useStepHeading';
import { gated } from './gated';
import { WrapUpActions, WrapUpFrame } from './WrapUpFrame';
import { WRAP_UP_PICTURES, WrapUpPicture } from './WrapUpPicture';

/** `/rewards-intro/`: what rewards are, before the points for the welcome call. */
function RewardsIntroStep() {
  const { t } = useTranslation('signup');
  const title = t('wrapUp.rewardsIntro.title');
  const headingRef = useStepHeading(title);
  const { goToStep } = useSignupNavigation();
  return (
    <WrapUpFrame
      title={title}
      description={t('wrapUp.rewardsIntro.description')}
      headingRef={headingRef}
    >
      <WrapUpPicture
        tone="pink"
        size="phone"
        src={WRAP_UP_PICTURES.rewardsPhone}
        data-testid="signup-rewards-intro-picture"
      />
      <WrapUpActions>
        <Button
          size="L"
          type="Primary"
          label={t('wrapUp.rewardsIntro.continue')}
          actionId="signup.rewards-intro-continue.activate"
          data-testid="signup-rewards-intro-continue-button"
          onPress={() => goToStep('rewards-points')}
        />
      </WrapUpActions>
    </WrapUpFrame>
  );
}

export const RewardsIntroScreen = gated(RewardsIntroStep, 'rewards-intro');
